export const GET_SERVICE_VEHICLE_RECORDS = "GET_SERVICE_VEHICLE_RECORDS";
export const ADD_SERVICE_VEHICLE_RECORD = "ADD_SERVICE_VEHICLE_RECORD";